module.exports = __webpack_public_path__ + "img/calendar-event-fill.fa012385.svg";